import { FleekError } from './FleekError';

type Domain = {
  id?: string;
  hostname?: string;
};

type DomainNotFoundErrorOptions = {
  domain: Domain;
};

export class DomainNotFoundError extends FleekError<DomainNotFoundErrorOptions> {
  public name = 'DomainNotFoundError';

  toString = () => {
    if (this.data.domain.hostname) {
      return `Domain ${this.data.domain.hostname} was not found.`;
    }

    return 'Domain was not found.';
  };
}
